export default __webpack_public_path__ + "static/media/overviewPic-en.53b93fa5.png";